import { FunctionComponent, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import TextEditor from '@Components/TextEditor';
import { ReactHookFormError } from '@Typings/global.types';

import TextFieldWrapperProps from './TextEditorFieldWrapper.types';

const TextEditorFieldWrapper: FunctionComponent<TextFieldWrapperProps> = (
  props: TextFieldWrapperProps
): JSX.Element => {
  const { name, readOnly, ...resProps } = props;
  const [validate, setValidate] = useState<boolean>(false);

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TextEditor
          {...resProps}
          readOnly={readOnly}
          value={field.value as string}
          error={!!errors[name]}
          errorText={(errors[name] as ReactHookFormError)?.message}
          onChange={(state: string) => {
            field.onChange(state);

            /* TO REMOVE HTML TAGS IF VALUE IS EMPTY
              This ensures validation works properly */
            const div = document.createElement('div');
            div.innerHTML = state || '';
            const text = div.textContent?.trim() || div.innerText?.trim() || '';

            setValue(name, text ? state : text, { shouldValidate: validate });
            if (text) {
              setValidate(true);
            }
          }}
        />
      )}
    />
  );
};

export default TextEditorFieldWrapper;
